import buildGroupMessagesRoute from "discourse/routes/build-group-messages-route";

export default buildGroupMessagesRoute("archive");
